var exports = {
  "Z": "xfd349460--b738fe--faq-icon",
  "Y": "xfd349460--b738fe--tooltip",
};

module.exports = exports;
